export const highlightWords = [
  // "December 25th \\(Christmas Day\\)",
  // "December 26th \\(St\\. Stephen's Day\\)",
  // "Christmas Eve \\(Wigilia\\)",
  // "Midnight Mass \\(Pasterka\\)",
  // "First Star \\(Pierwsza Gwiazdka\\)",
  // "Abstinence and Fasting:",
  // "Opłatek:",
  // "The Feast of Wigilia:",
  // "Drugi Dzień Świąt",
  // "kolędy",
  // "Kolędy",
  // 'Wielkanoc',
  // 'Wielki Tydzień',
  // 'Niedziela Palmowa',
  // '\\(Wielki Piątek\\)',
  // 'Droga Krzyżowa',
  // '\\(Wielka Sobota\\)',
  // 'Baskets',
  // '\\(Święcenie Pokarmów\\)',
  // 'Święconka',
  // '\\(Jajka\\)',
  // 'Chleb',
  // 'Sól',
  // '\\(Chrzan\\)',
  // '\\(Szynka\\)',
  // '\\(Kiełbasa\\)',
  // '\\(Masło\\)',
  // 'Żurek',
  // 'Biała kiełbasa',
  // 'Babka',
  // 'Mazurek',
  // 'pasztet',
  // 'Śmigus-Dyngus',
  // 'Pisanki',
  // 'Kraszanki',
  // 'Drapanki',
  // 'Malowanki',
  // 'Wyklejanki',
  // '\\(Baranek Wielkanocny\\)',
  // '\\(Palmy Wielkanocne\\)',
  // '"Siuda Baba"',
];

export const highlightText = (text, additionalClass = "") => {
  if (!text) return "";
  const regex = new RegExp(`(${highlightWords.join("|")})`, "g");
  return text.replace(
    regex,
    `<span class="highlight ${additionalClass}">$1</span>`
  );
};

export const findSectionByTitle = (sections, title) => {
  for (const section of sections) {
    if (section.title.toLowerCase() === title.toLowerCase()) {
      return section;
    }
    if (section.sections) {
      const found = findSectionByTitle(section.sections, title);
      if (found) return found;
    }
  }
  return null;
};